import routes from '../routes';
import { UserTypes } from 'src/modules/Auth/store/types';
import { RoutePathsFn, IRouteModule, RoutesModules } from '../types';
import News from '../../News/News';

const moduleRoutes: RoutePathsFn = () => ([
  {
    paths: [routes.NEWS],
    component: News,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  }
]);

export const newsModule = (): IRouteModule => ({
  name: RoutesModules.NEWS,
  routes: moduleRoutes(),
  navbar: routes.NEWS,
  sidebar: [
    {
      navTitle: 'News',
      route: routes.NEWS,
      hideOnMobile: true
    }
  ]
});


// WEBPACK FOOTER //
// ./src/modules/Routing/modules/news.ts